import { Environments } from '../../utils/environment';

export interface MapboxConfig {
	key: string;
	arcGISKey: string;
}

export interface Auth0Config {
	domain: string;
	clientId: string;
	audience: string;
	tokenKeyPrefix: string;
}

export interface ForgeConfig {
	domain: string;
	clientId: string;
	clientSecret: string;
	clsDomain?: string;
	clsClientId?: string;
	clsClientSecret?: string;
	featureId: string;
	audience: string;
	tokenKeyPrefix: string;
	portalDomain: string;
	cpaHubsDomain: string;
	cpaProjectsDomain: string;
	forceExpireInMinutes?: number;
	/**
	 * Token access
	 * @default 'openid data:read'
	 */
	scope?: string;
}

type AdpProvider = 'appkey' | 'cls' | 'o2' | 'upi1' | 'upi2';
type AdpEnv = 'dev' | 'stg' | 'prd';
type AdpRegion = 'us' | 'eu' | 'ap';

export interface AdpConfig {
	name: string;
	id: string;
	id_provider: AdpProvider;
	key: string;
	env: AdpEnv;
	region: AdpRegion;
}

export interface HarviConfig {
	api: string;
}

export interface AssetService {
	api: string;
}

export interface IncidentService {
	api: string;
}

export interface SimulationService {
	api: string;
}

export interface RemoteUrlConfig {
	baseUrl: string;
}

export interface LaunchDarklyConfig {
	clientSideId: string;
	liveUpdates?: boolean;
}

export interface GainsightConfig {
	clientSideId: string;
	plantClientSideId: string;
}

export interface ImagesConfig {
	destinationBucket: string;
}

export interface ReportsConfig {
	destinationBucket: string;
}

export interface EsriConfig {
	clientId: string;
	refreshTokenExpiresIn?: number;
}

export interface SiteConfig {
	/**
	 * This gets set by the SiteConfigProvider
	 */
	env?: Environments;
	apiEnv?: Environments;
	apiRegion?: string;
	/**
	 * An object for site config provider to load key value pairs into the localStorage "onu" value.
	 * Very useful for things like apiEnv that you may want to quickly switch between
	 * while developing.
	 */
	storage?: object;
	mapbox: MapboxConfig;
	auth0: Auth0Config;
	forge?: ForgeConfig;
	adp?: AdpConfig;
	harvi: HarviConfig;
	remoteUrl: RemoteUrlConfig;
	assets: AssetService;
	incidents: IncidentService;
	simulations: SimulationService;
	launchDarkly: LaunchDarklyConfig;
	gainsight?: GainsightConfig;
	images?: ImagesConfig;
	reports?: ReportsConfig;
	esri?: EsriConfig;
}
